// removed by extract-text-webpack-plugin
module.exports = {"body":"c350dd6ed5_src-auth-LoginPage-_LoginPage_body","box":"c1e1dce19d_src-auth-LoginPage-_LoginPage_box","bottom":"_98a6a55c13_src-auth-LoginPage-_LoginPage_bottom","error":"_35a139ce3f_src-auth-LoginPage-_LoginPage_error"};


//////////////////
// WEBPACK FOOTER
// ./src/auth/LoginPage/LoginPage.css
// module id = 1553
// module chunks = 0